import {
    Typography,
    TextField,
    Button,
    Backdrop,
    CircularProgress,
} from "@mui/material";
import { Box, Stack } from "@mui/system";
import React, { useState } from "react";
import { Icons } from "../../../components/icons";
import { toast } from "react-toastify";
import fuse_bulb from "../../../assests/fuse bulb.svg";
import hove_bulb from "../../../assests/State=Hover.svg";
import default_bulb from "../../../assests/State=Default.svg";
import Accordion from '@mui/material/Accordion';
import { hintFlagCorporate, submitFlagCorporate } from "../../../APIConfig/NewCorporateApiConfig";
import LightbulbOutlinedIcon from '@mui/icons-material/LightbulbOutlined';
import TipsAndUpdatesTwoToneIcon from '@mui/icons-material/TipsAndUpdatesTwoTone';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Tooltip from "@mui/material/Tooltip";



const FlagTTX = ({
    item,
    flag_id,
    flagLoader,
    setFlagLoader,
    flagData,
    param_id,
    is_started,
    is_ended
}) => {
    const [hoveredFlag, setHoveredFlag] = useState(null);
    const [inputValue, setInputValue] = useState({});

    console.log(is_started,
        is_ended, 'itemitem');



    const flagSubmit = async (param_id, id, val) => {
        try {
            const response = await submitFlagCorporate(param_id, id, { answer: val });
            const msg = response?.data?.is_correct;
            if (msg) {
                toast.success(response?.data?.message || "Correct answer");
                setInputValue(prev => ({
                    ...prev,
                    [id]: ""
                }));
            }
            else {
                // fallback if backend sends 200 with other msg
                toast.success(msg || "Submitted");
            }
        }
        catch (error) {
            if (error?.response?.data?.message || error?.response?.data?.is_correct === false) {
                return;
            }
        }
        finally {
            setFlagLoader(true);
        }
    };


    const handleHintUsed = async (param_id, id) => {
        try {
            const hint = await hintFlagCorporate(param_id, id);
            hint && toast.info(
                hint?.data?.message?.length < 12
                    ? hint?.data?.message
                    : "Hint fetched"
            );
            setFlagLoader(true)  // ← Set to true directly after successful hint

        } catch (error) {
            console.error("Error fetching hint:", error);
            toast.error("Failed to fetch hint");
        } finally {
            setFlagLoader(true);
        }
    };

    return (
        <>

            <Backdrop
                sx={{
                    color: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                    backgroundColor: "transparent"
                }}
                open={flagLoader}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* first render when phase id is not available and no accordian for phase and flag question will render directly */}
            {
                flagData?.length > 0 ? (
                    flagData?.map((flag_item, index) => (
                        <FlagUITTX
                            key={flag_item?.flag_id}
                            flag_item={flag_item}
                            index={index}
                            length={flagData?.length}
                            flagLoader={flagLoader}
                            inputValue={inputValue}
                            setInputValue={setInputValue}
                            flagSubmit={flagSubmit}
                            // isHovered={isHovered}
                            // setIsHovered={setIsHovered}
                            hint_used={flag_item?.is_hint_used}
                            flag_id={flag_id}
                            handleHintUsed={handleHintUsed}
                            hoveredFlag={hoveredFlag}
                            setHoveredFlag={setHoveredFlag}
                            participant_id={flag_item?.participant_id}
                            param_id={param_id}
                        />
                    ))

                ) : (
                    <Typography sx={{ color: "#999", p: 2 }}>
                        No Flags Available
                    </Typography>
                )

            }
        </>
    )
};

export default FlagTTX;





const FlagUITTX = (
    {
        flag_item,
        index,
        length,
        inputValue,
        setInputValue,
        flagSubmit,
        hint_used,
        handleHintUsed,
        hoveredFlag,
        setHoveredFlag,
        param_id

    }
) => {

    return (<Box key={flag_item?.flag_id} sx={{ display: "flex", justifyContent: "left", gap: 1, width: "100%" }}>

        <Box sx={{ display: "flex", justifyContent: "left", gap: 1, width: "100%" }}>


            {/* circle path for indexing */}
            <Stack alignItems="center" sx={{ flexShrink: 0 }}>
                <Box
                    width={20}
                    height={20}
                    borderRadius="50%"
                    sx={{
                        backgroundColor: flag_item?.correct_answered ? "#039855" : "#F79D28",
                        textAlign: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        display: "flex",
                        p: 2,
                        color: "white",
                        border: "0.5px solid white",
                    }}
                >
                    {flag_item?.correct_answered ? "✓" : index + 1}
                </Box>

                <Box
                    border="1px solid white"
                    height="100%"
                    sx={{ display: length - 1 === index && "none" }}
                />
            </Stack>

            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                    width: "100%",
                    flex: 1,
                    minWidth: 0,
                    py: 1
                }}
            >
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Typography sx={{ flexShrink: 0 }}>Q{index + 1}.</Typography>
                    <Typography sx={{ wordBreak: "break-word", overflowWrap: "anywhere", flex: 1, minWidth: 0 }}>
                        {/* ({flag_item?.id})  */}
                        {flag_item?.question} ({flag_item?.score})
                    </Typography>
                </Box>


                {/* correct answered not submitted then user can submit the answer in the text field */}
                {!flag_item?.correct_answered && (
                    <Stack
                        direction="row"
                        position="relative"
                        display={"flex"}
                        sx={{ alignItems: "center" }}
                        width={"100%"}
                        gap={1}
                    >
                        <TextField
                            fullWidth
                            maxRows={4}
                            variant="standard"
                            placeholder={flag_item?.placeholder || "Enter your flag"}
                            style={{
                                flex: 1,
                                backgroundColor: "#1C1F28",
                                borderRadius: "8px",
                                color: "#acacac",
                                border: "none",
                                padding: "12px 14px",
                            }}
                            name={flag_item.flag_id}
                            value={inputValue[flag_item?.flag_id] || ""}
                            onChange={(e) =>
                                setInputValue((prev) => ({
                                    ...prev,
                                    [flag_item.flag_id]: e.target.value.trimStart(),
                                }))
                            }
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    flagSubmit(param_id, flag_item?.id, inputValue[flag_item.flag_id]);
                                }
                            }}
                        />

                        <Box
                            onClick={() => flagSubmit(param_id, flag_item?.id, inputValue[flag_item.flag_id])}
                            sx={{
                                cursor: "pointer",
                                padding: "12px 14px",
                                border: '1px solid #343434',
                                borderRadius: '5px',
                                color: '#FFFFFF',
                                flexShrink: 0,
                                whiteSpace: "nowrap",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: inputValue[flag_item.flag_id] ? '#2DB06A' : '#272727',
                                "&:hover": {
                                    backgroundColor: '#249a5b'
                                }
                            }}
                        >
                            Submit
                        </Box>
                    </Stack>
                )}

                {/* if hint already used then show hint and and correct answer not submitted*/}
                {flag_item?.is_hint_used && !flag_item?.correct_answered && (
                    <Box
                        sx={{
                            display: "flex",
                            gap: "6px",
                            pr: "38px",
                        }}
                    >
                        <Box>Hint:</Box>
                        <Box>{flag_item?.hints[0]}</Box>
                    </Box>
                )}


                <Stack direction={'row'} alignItems={'center'} gap={1} >
                    <Tooltip title={`Using this hint will reduce your score by ${flag_item?.hint_penalty}`} placement="right" arrow >
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "75px",
                            height: "58px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            gap: '4px'
                        }}>
                            <InfoOutlinedIcon />
                            View

                        </Box>
                    </Tooltip>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: "75px",
                            height: "58px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                            gap: '4px'
                        }}
                        onMouseEnter={() => setHoveredFlag(flag_item?.flag_id)}
                        onMouseLeave={() => setHoveredFlag(null)}
                        onClick={() => {
                            if (flag_item?.is_hint_used) {
                                toast.info("Hint already used");
                            } else {
                                handleHintUsed(param_id, flag_item?.id);
                            }
                        }}
                    >
                        {flag_item?.is_hint_used ? (
                            <LightbulbOutlinedIcon
                                sx={{
                                    color: "#f5c518",
                                    fontSize: 28,
                                    transition: "all 0.2s ease"
                                }}
                            />
                        ) : hoveredFlag === flag_item?.flag_id ? (
                            <TipsAndUpdatesTwoToneIcon
                                sx={{
                                    color: "#f5c518 !important",
                                    fill: '#f5c518',
                                    fontSize: 30,
                                    transform: "scale(1.2)",
                                    transition: "all 0.2s ease",
                                    filter: "drop-shadow(0 0 6px rgba(245,197,24,0.6))"
                                }}
                            />
                        ) : (
                            <LightbulbOutlinedIcon
                                sx={{
                                    color: "#8c8c8c",
                                    fontSize: 26,
                                    transition: "all 0.2s ease"
                                }}
                            />
                        )}

                        Hint
                    </Box>

                </Stack>
            </Box>
        </Box>
    </Box >)
}
